import { FunctionComponent } from "react";

import InformationCircle from "@/assets/icons/information-circle.svg";
import { useIntercom } from "@/hooks/useIntercom";
import { cx } from "@/utils";
import Tooltip from "@components/Tooltip";

import styles from "./InfoLink.module.css";

type InfoLinkProps = {
  content: string;
  href?: string;
  className?: string;
};

const HELP_ARTICLE_URL = "https://help.allears.ai/sv/articles/";
const extractArticleId = (url: string) =>
  url.replace(HELP_ARTICLE_URL, "").split("-")?.[0] || "";

const InfoLink: FunctionComponent<InfoLinkProps> = ({
  content,
  href,
  className,
}) => {
  const { showArticle } = useIntercom();
  const isIntercomArticle = href?.startsWith(HELP_ARTICLE_URL);
  return (
    <Tooltip content={content}>
      {href ? (
        <a
          onClick={
            isIntercomArticle
              ? (e) => {
                  const articleId = extractArticleId(href);
                  if (articleId && showArticle) {
                    e.preventDefault();
                    showArticle(articleId);
                  }
                }
              : undefined
          }
          href={href}
          target={href ? "_blank" : undefined}
          className={cx(styles.root, className)}
          rel="noreferrer"
        >
          <InformationCircle width={14} />
        </a>
      ) : (
        <span className={cx(styles.root, className)}>
          <InformationCircle width={14} />
        </span>
      )}
    </Tooltip>
  );
};

export default InfoLink;
